import { render, staticRenderFns } from "./indexHome.vue?vue&type=template&id=fd57f3bc&scoped=true&"
import script from "./indexHome.vue?vue&type=script&lang=js&"
export * from "./indexHome.vue?vue&type=script&lang=js&"
import style0 from "./indexHome.vue?vue&type=style&index=0&id=fd57f3bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd57f3bc",
  null
  
)

export default component.exports